import React from "react";
import ImageHelper from "../helpers/imageHelper";
import { isTiffPreviewPath } from "../helpers/tiffHelper";

/** Resolves a displayable <img src> string, or "" when content is not a viewable image. */
export const resolveImageSrc = (
  fileName?: string,
  fileContent?: string,
  fileContentType?: string,
): string => {
  if (
    isTiffPreviewPath(
      fileContent || "",
      fileName || "",
      fileContentType || "",
    )
  ) {
    return "";
  }

  if (
    !ImageHelper.isImageContent(
      fileContent || "",
      fileContentType || "",
      fileName || "",
    )
  ) {
    return "";
  }

  return ImageHelper.formatImageContent(fileContent || "", fileContentType);
};

export interface ImageViewerProps {
  fileName?: string;
  src: string;
}

const ImageViewer: React.FC<ImageViewerProps> = ({ fileName, src }) => {
  if (!src) {
    return null;
  }

  return (
    <div className="flex-1 min-h-0 overflow-auto p-3 border-t border-hex-gray-100">
      <div className="flex min-h-full min-w-0 items-center justify-center">
        <img
          src={src}
          alt={fileName ? `Preview: ${fileName}` : "Image preview"}
          className="max-w-full h-auto object-contain shadow-xs rounded"
          draggable={false}
          onDragStart={(e) => e.preventDefault()}
        />
      </div>
    </div>
  );
};

export default ImageViewer;
